import CloseIcon from '@mui/icons-material/Close';
import JxLineEdit from './JxLineEdit';
import './JxFilterEdit.css';

const STRIP_PROPS = [];

/**
 * JxFilterEdit — controlled filter input, extends JxLineEdit.
 * Unlike JxSearchEdit (debounced, minLength, meant for server search), JxFilterEdit is
 * for instant client-side list filtering — caller owns the value via onChange (same
 * controlled pattern as JxLineEdit itself), fires on every keystroke, no debounce.
 * Built-in clear (X) button in the suffix slot, shown only when non-empty.
 *
 * @param {string} id
 * @param {string} value
 * @param {(value: string) => void} onChange
 * @param {string} [placeholder='Filter…']
 */
export default class JxFilterEdit extends JxLineEdit {
    getPlaceholder() {
        return this.props.placeholder ?? 'Filter…';
    }

    getSuffix() {
        if (!this.props.value) return null;
        return <CloseIcon className="jx-filter-edit-clear" onClick={() => this.props.onChange('')} />;
    }

    getPropsToOmit() {
        return STRIP_PROPS;
    }
}
